<input
  type="checkbox"
  [id]="uniqueId"
  [checked]="checked"
  [disabled]="disabled"
  (change)="handleChange($event.target)"
/>

<label [for]="uniqueId">
  <div class="label-content">
    <ng-content></ng-content>
  </div>
</label>
